import { gql } from "../../__generated__";

export const START_PRO_PHONE_VERIFICATION = gql(`
	mutation StartProPhoneNumberVerification($phoneNumber: String!) {
		startProPhoneNumberVerification(phoneNumber: $phoneNumber)
	}
`);

export const SEND_OTP = gql(`
	mutation SendOTP($phoneNumber: String!) {
		sendOneTimePasscode(phoneNumber: $phoneNumber) 
	}
`);

export const VERIFY_OTP = gql(`
	mutation VerifyProOTP($phoneNumber: String!, $otp: String!) {
		verifyProPhoneNumber(phoneNumber: $phoneNumber, code: $otp) {
			success
			message
			code
		}
	}
	`);

export const ADD_PROJECT_HISTORY = gql(`
  mutation AddPorfolioWorkHistoryItem(
    $name: String!
    $description: String!
    $startedAt: DateTimeISO
    $images: [JobImage!]!
    $videos: [String!]!
    $budget: Float
		$proDoesNotWishToDiscloseBudget: Boolean!
    $endedAt: DateTimeISO!
  ) {
    addPorfolioWorkHistoryItem(
      name: $name
      description: $description
      startedAt: $startedAt
      images: $images
      videos: $videos
      budget: $budget
      proDoesNotWishToDiscloseBudget: $proDoesNotWishToDiscloseBudget
      endedAt: $endedAt
    )
  } 
`);

export const ADD_EMPLOYMENT_HISTORY_ITEM = gql(`
	mutation AddPortfolioEmploymentHistoryItem($companyName: String!,
	 $jobTitle: String!, $description: String!, $startedAt: DateTimeISO!,
	$proDoesNotWishToDiscloseMonthlySalary: Boolean!, $images: [JobImage!]!,
	$endedAt: DateTimeISO, $monthlySalary: Float) {
  addPortfolioEmploymentHistoryItem(companyName: $companyName, jobTitle: $jobTitle,
	description: $description, startedAt: $startedAt, proDoesNotWishToDiscloseMonthlySalary: $proDoesNotWishToDiscloseMonthlySalary,
	images: $images, endedAt: $endedAt, monthlySalary: $monthlySalary) {
    id
    jobTitle
  }
}
`);

export const EDIT_EMPLOYMENT_HISTORY_ITEM = gql(`
	mutation EditPortfolioEmploymentHistoryItem(
		$id: String!
		$companyName: String
		$jobTitle: String
		$description: String
		$startedAt: DateTimeISO
		$endedAt: DateTimeISO
		$existingImageIds: [String!]
		$images: [JobImage!]
		$monthlySalary: Float
		$proDoesNotWishToDiscloseMonthlySalary: Boolean
	) {
		editPortfolioEmploymentHistoryItem(
			id: $id
			companyName: $companyName
			jobTitle: $jobTitle
			description: $description
			startedAt: $startedAt
			endedAt: $endedAt
			existingImageIds: $existingImageIds
			images: $images
			monthlySalary: $monthlySalary
			proDoesNotWishToDiscloseMonthlySalary: $proDoesNotWishToDiscloseMonthlySalary
		) {
			id
			isPinned
			companyName
			jobTitle
			description
			startedAt
			endedAt
			images {
				id
				name
				thumbnailUrl
				originalUrl
			}
			monthlySalary
			proDoesNotWishToDiscloseMonthlySalary
		}
	}
`);

export const EDIT_PROJECT_HISTORY = gql(`
  mutation EditPortfolioWorkHistoryItem(
    $id: String!
    $name: String
    $description: String
    $startedAt: DateTimeISO
		$existingImageIds: [String!]
    $images: [JobImage!]
    $videos: [String!]
    $budget: Float
		$proDoesNotWishToDiscloseBudget: Boolean
    $endedAt: DateTimeISO
  ) {
    editPortfolioWorkHistoryItem(
      id: $id
      name: $name
      description: $description
      startedAt: $startedAt
      existingImageIds: $existingImageIds
      images: $images
      videos: $videos
      budget: $budget
      proDoesNotWishToDiscloseBudget: $proDoesNotWishToDiscloseBudget
      endedAt: $endedAt
    ) {
      id
      name
      description
      startedAt
      endedAt
      images {
				id
				name
			}
      videos
      budget
			proDoesNotWishToDiscloseBudget
      clientReview {
        rating
        feedback
      }
      verified
    }
  }
`);

export const REMOVE_PROJECT_HISTORY = gql(`
  mutation RemovePortfolioWorkHistoryItem($id: String!) {
    removePortfolioWorkHistoryItem(id: $id) {
      id
    }
  }
`);

export const REMOVE_EMPLOYMENT_HISTORY_ITEM = gql(`
	mutation RemovePortfolioEmploymentHistoryItem($id: String!) {
		removePortfolioEmploymentHistoryItem(id: $id) {
			id
		}
	}
`);
